import * as React from 'react';
import RoleDropdown from 'components/RoleDropdown/RoleDropdown';
import { SelectChangeEvent } from '@mui/material';
import Grid from '@mui/material/Grid2';

interface SelectedUserType {
  memberId?: string;
  affPinNum?: string;
  user?: {
    userId: number;
    firstName: string;
    lastName: string;
    username: string;
  };
  role: {
    roleId: number;
    roleName: string;
  };
}

interface IRoleDropdownHOCForUserManagementAccountCreationProps {
  selectedUser: SelectedUserType | undefined;
  onChangeInputFields?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  selectedPropsValue?: string | number | undefined;
  setSelectedPropsValue?: (value: string | number) => void;
  dropdownOnChange?: (e: SelectChangeEvent<string>) => void;
  memberIdRequired?: (value: number, text?: string) => boolean;
  affiliatePinRequired?: (value: number) => boolean;
}

const RoleDropdownHOCForUserManagementAccountCreation: React.FC<
  IRoleDropdownHOCForUserManagementAccountCreationProps
> = (props) => {
  const [selectedPropsText, setSelectedPropsText] = React.useState('');
  const [selectedPropsValue, setSelectedPropsValue] = React.useState(Number(props.selectedPropsValue) || 1);

  const dropdownOnChange = (e: SelectChangeEvent<string>) => {
    const newValue = Number(e.target.value);
    setSelectedPropsValue(newValue);
    // Get the text from the event or use the value as fallback
    const selectedText = e.target.value || '';
    setSelectedPropsText(selectedText);
    if (props.dropdownOnChange) {
      props.dropdownOnChange(e);
    }
  };

  return (
    <Grid container spacing={3}>
      <Grid size={{ xs: 12, md: 12 }}>
        <RoleDropdown
          id={'user-management-create-user-role-selection'}
          isNewUser={true}
          selectedUser={props.selectedUser!}
          selectedPropsValue={props.selectedPropsValue}
          setSelectedPropsValue={setSelectedPropsValue}
          setSelectedPropsText={setSelectedPropsText}
          onDropdownChange={dropdownOnChange}
        />
      </Grid>
    </Grid>
  );
};

export default RoleDropdownHOCForUserManagementAccountCreation;
